import styled from 'styled-components';
import ds, { media } from 'designsystem';

const Paragraph = styled.p`
  color: ${ds.brand('text')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.light')};
  font-size: ${ds.fs('base')};
  line-height: ${ds.get('type.lineHeight.s')};
  
  ${media.tablet`
    font-size: ${({ blogArticle }) => (blogArticle ? ds.fs('blogArticleParagraph') : ds.fs('base'))};
    line-height: ${({ blogArticle }) => (blogArticle ? ds.get('type.lineHeight.l') : ds.get('type.lineHeight.s'))};
  `}

  & strong{
    font-weight: ${ds.get('type.fontWeight.bold')};
  }
`;

export default Paragraph;



// WEBPACK FOOTER //
// ./src/elements/Paragraph.js